/***
 * Created on 2023/7/25
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import i18n from "i18next";
import { initReactI18next} from "react-i18next";
import Backend from 'i18next-http-backend';
import {detectDefaultLanguage} from "./service/common";

// Since there is no backend this will fail at test time, therefore we need to exclude this part from test
if (process.env.NODE_ENV !== 'test') {
    i18n.use(Backend);
}

i18n.use(initReactI18next)
    .init({
        fallbackLng: 'en',
        lng: detectDefaultLanguage(),
        debug: false,
        interpolation: {
            escapeValue: false
        },
        load: "currentOnly",
        react: {
            useSuspense: true
        },
        backend: {
            loadPath: `${window.acc_mf.common.APP_CDN_URL}/acc-mf/root/qcloud-l10n/json/{{lng}}.json`
        }
    });

export default i18n;